import InsightsTabRoute from './subpages/insights-tab/route'
import PredictionsTabRoute from './subpages/predictions-tab/route'

export default {
  path: '/financial',
  component: () => import(/* webpackChunkName: "financial" */ './Financial'),
  meta: {
    requiresAuth: true
  },
  redirect: '/financial/insights',
  children: [InsightsTabRoute, PredictionsTabRoute]
}
